const homeEN = {
  home_nav_about: 'About',
  home_nav_companies: 'Our Companies',
  home_nav_services: 'Services',
  home_nav_investment: 'Investment',
  home_nav_contact: 'Contact',
  home_nav_getStarted: 'Get Started',

  home_hero_badge: "Leading Holding Company in African Development",
  home_hero_title: "Connecting Africa's Future\nTo Global Opportunities",
  home_hero_subtitle: "Strategic partnerships • Investment facilitation • Sustainable development across Africa",
  home_hero_cta1: 'Explore Our Companies',
  home_hero_cta2: 'View Projects',

  home_about_tag: 'Who We Are',
  home_about_title: "Positioned at the Heart of Africa's Decision-Making Ecosystem",
  home_about_desc: "Through our extensive network of government leaders, institutional partners, and global investors, we help bring transformational projects to life across the continent. GDSATLAS serves as the vital bridge connecting visionary projects with the resources and partnerships needed to make them reality.",
  home_about_quote: "Our mission is to facilitate strategic partnerships, mobilize international investment, and deliver sustainable development projects in Africa through our specialized subsidiaries.",
  home_about_badge: '50+',
  home_about_badge_sub: 'Partners',

  home_exp_tag: 'Our Expertise',
  home_exp_title: 'Comprehensive Solutions for African Development',
  home_exp_subtitle: 'We specialize in connecting businesses with opportunities across multiple sectors',
  home_exp_c1_title: 'Project Facilitation',
  home_exp_c1_desc: "Connecting businesses with African leaders, decision-makers, and investors to bring transformative projects to life across the continent. We navigate complex regulatory environments and build the bridges needed for success.",
  home_exp_c1_t1: 'Government Liaison',
  home_exp_c1_t2: 'Deal Structuring',
  home_exp_c1_t3: 'Regulatory Navigation',
  home_exp_c2_title: 'Advisory & Consulting',
  home_exp_c2_l1: 'Public-Private Partnerships (PPP)',
  home_exp_c2_l2: 'Build-Operate-Transfer (BOT) models',
  home_exp_c2_l3: 'Market entry strategies',
  home_exp_c2_l4: 'Investment structuring',
  home_exp_c2_t1: 'PPP',
  home_exp_c2_t2: 'BOT',
  home_exp_c2_t3: 'Strategy',
  home_exp_c3_title: 'Investment Solutions',
  home_exp_c3_desc: "Securing funding and partnerships through our international network of investors, providing access to capital for transformative projects across Africa. We match the right investors with the right opportunities.",
  home_exp_c3_t1: 'Capital Mobilization',
  home_exp_c3_t2: 'Investor Matching',
  home_exp_c3_t3: 'Risk Assessment',
  home_exp_c4_title: 'Sector Expertise',
  home_exp_c4_l1: 'Oil and Gas',
  home_exp_c4_l2: 'Infrastructure Development',
  home_exp_c4_l3: 'Energy & Mining',
  home_exp_c4_l4: 'Agriculture & Logistics',
  home_exp_c4_t1: 'Oil & Gas',
  home_exp_c4_t2: 'Mining',
  home_exp_c4_t3: 'Infrastructure',

  home_part_tag: 'Partnership Capacities',
  home_part_title: 'Built for Strategic Business Partnerships',
  home_part_subtitle: 'GDSATLAS brings together the networks, expertise, and operational capacity to make high-impact partnerships a reality across Africa',
  home_part_f1_tag: 'Strategic Alliances',
  home_part_f1_title: 'Government & Institutional Partnerships',
  home_part_f1_desc: 'Direct relationships with heads of state, ministers, and institutional bodies across West Africa, enabling fast-track approvals and privileged access to strategic opportunities.',
  home_part_f2_tag: 'Global Reach',
  home_part_f2_title: 'International Investor Network',
  home_part_f2_desc: 'Access to a curated network of global investors actively seeking African growth opportunities.',
  home_part_f3_tag: 'Infrastructure',
  home_part_f3_title: 'Large-Scale Project Execution',
  home_part_f4_tag: 'Energy',
  home_part_f4_title: 'Sustainable Energy Ventures',
  home_part_f5_tag: 'Agriculture',
  home_part_f5_title: 'Agribusiness & Food Security',
  home_part_s1_value: '15+',
  home_part_s1_label: 'Government Partners',
  home_part_s1_sub: 'Across West Africa',
  home_part_s2_value: '30+',
  home_part_s2_label: 'International Investors',
  home_part_s2_sub: 'Active in our network',
  home_part_s3_value: '$2B+',
  home_part_s3_label: 'Projects Facilitated',
  home_part_s3_sub: 'In total value',
  home_part_s4_value: '8+',
  home_part_s4_label: 'African Countries',
  home_part_s4_sub: 'Active operations',

  home_sub_tag: 'Our Companies',
  home_sub_title: 'Three Specialized Subsidiaries',
  home_sub_subtitle: 'Fully owned by GDSATLAS, our companies deliver excellence in mining, logistics, and fisheries',
  home_compass_title: 'Compass Resources',
  home_compass_desc: "Forward-thinking mining company dedicated to sustainable exploration and exploitation of Mauritania's rich mineral resources including gold, uranium, copper, quartz, and black sand.",
  home_compass_stat1: '1,352 km²',
  home_compass_stat1_label: 'Total License Area',
  home_compass_stat2: '5+',
  home_compass_stat2_label: 'Mineral Resources',
  home_compass_cta: 'Explore Mining Operations',
  home_mauritrans_title: 'Mauritrans Shipping',
  home_mauritrans_desc: 'Comprehensive logistics and transport shipping company providing end-to-end maritime services, freight forwarding, customs clearance, and supply chain solutions across Africa and internationally.',
  home_mauritrans_stat1: '500+',
  home_mauritrans_stat1_label: 'Annual Shipments',
  home_mauritrans_stat2: '9',
  home_mauritrans_stat2_label: 'Service Categories',
  home_mauritrans_cta: 'Explore Logistics Services',
  home_transfish_title: 'Trans-Fish',
  home_transfish_desc: 'A dynamic company operating in the fisheries sector, leveraging Mauritania\'s rich Atlantic coastal waters to deliver sustainable fishing operations, seafood processing, and export solutions across international markets.',
  home_transfish_stat1: 'Atlantic',
  home_transfish_stat1_label: 'Coastal Operations',
  home_transfish_stat2: 'Export',
  home_transfish_stat2_label: 'International Markets',
  home_transfish_cta: 'Visit Trans-Fish Website',

  home_inv_title: "Ready to Invest\nin Africa?",
  home_inv_desc: "GDSATLAS welcomes partnerships across Infrastructure, Energy,\nMining, Agriculture, and Industrial Development sectors.",
  home_inv_cta1: 'Explore Opportunities',
  home_inv_cta2: 'Schedule Consultation',

  home_why_tag: 'Why Partner With Us',
  home_why_title: 'Your Gateway to African Success',
  home_why_subtitle: 'Leveraging deep expertise and extensive networks to deliver exceptional results',
  home_why_01_title: 'Strong Government Relations',
  home_why_01_desc: 'Direct access to African decision-makers and government leaders across multiple countries',
  home_why_02_title: 'Global Investor Network',
  home_why_02_desc: 'Extensive connections with international investors seeking African opportunities',
  home_why_03_title: 'PPP & BOT Expertise',
  home_why_03_desc: 'Specialized knowledge in structuring Public-Private Partnerships and Build-Operate-Transfer projects',
  home_why_04_title: 'Integrated Logistics',
  home_why_04_desc: 'Comprehensive shipping and logistics capabilities ensuring seamless project execution',
  home_why_05_title: 'African Market Intelligence',
  home_why_05_desc: 'Deep understanding of local markets, regulations, and business environments',
  home_why_06_title: 'Proven Track Record',
  home_why_06_desc: 'Successfully facilitated numerous transformational projects across the continent',

  home_contact_tag: 'Get In Touch',
  home_contact_title: "Let's Build Africa's Future Together",
  home_contact_subtitle: 'Contact GDSATLAS to discuss your project or investment opportunities',
  home_contact_addr_label: 'Address',
  home_contact_phone_label: 'Phone',
  home_contact_email_label: 'Email',
  home_contact_web_label: 'Website',
  home_contact_subs_title: 'Our Subsidiaries',
  home_contact_compass: 'Compass Resources - Mining Operations',
  home_contact_mauritrans: 'Mauritrans Shipping - Logistics Services',
  home_contact_transfish: 'Trans-Fish - Fisheries & Seafood Export',
  home_form_title: 'Send us a message',
  home_form_name: 'Name',
  home_form_name_ph: 'Your name',
  home_form_email: 'Email',
  home_form_email_ph: 'your@email.com',
  home_form_message: 'Message',
  home_form_message_ph: 'Tell us about your project or inquiry',
  home_form_submit: 'Send Message',

  home_footer_tagline: 'Connecting Africa to Global Opportunities',
  home_footer_subscribe: 'Stay Updated',
  home_footer_subscribe_ph: 'Enter your email',
  home_footer_subscribe_btn: 'Subscribe',
  home_footer_companies: 'Our Companies',
  home_footer_services: 'Services',
  home_footer_svc1: 'Project Facilitation',
  home_footer_svc2: 'Advisory & Consulting',
  home_footer_svc3: 'Investment Solutions',
  home_footer_svc4: 'Sector Expertise',
  home_footer_contact: 'Contact',
  home_footer_copyright: '© 2025 GDSATLAS Holding. All rights reserved.',
};

export default homeEN;
